<template>
  <refonte-item-file-convention
    v-if="!props.signature_manuelle && props.convention.typeSignatureId == 1"
    v-bind:title="props.title"
    v-bind:subtitle="props.subtitle"
    v-bind:convention="props.convention"
    v-bind:on_click_download="
      () => downloadConvention(props.client_id, props.convention)
    "
    v-bind:on_close="props.on_close"
    v-bind:on_submit="props.on_submit"
    v-bind:client_id="props.client_id"
    v-bind:participant_nom_prenom="props.participant_nom_prenom"
    v-bind:session_date="props.session_date"
    v-bind:formation_title="props.formation_title"
    v-bind:open_signature_manuelle="props.open_signature_manuelle"
    v-bind:id="props.id" />
  <refonte-item-file
    v-bind:id="props.id"
    v-if="props.signature_manuelle || props.convention.typeSignatureId == 2"
    v-bind:title="props.title"
    v-bind:subtitle="props.subtitle"
    v-bind:on_click_download="
      () => downloadConvention(props.client_id, props.convention)
    "
    v-bind:file_signed="props.convention.signee || props.convention.validee"
    v-bind:upload_url="
      getConventionUploadUrl(props.client_id, props.convention)
    "
    v-bind:file_signed_editable="!props.convention.validee"
    v-bind:on_click_upload_refresh="props.on_submit" />
</template>

<script setup lang="ts">
  import {
    downloadConvention,
    getConventionUploadUrl
  } from '@/mixin/client_download__functions';
  import RefonteItemFile from '@/components/refonte/items/refonte-item-file.vue';
  import RefonteItemFileConvention from '@/components/refonte/items/refonte-item-file-convention.vue';
  import { ConventionDocument } from '@/types/gestion/inscriptions-types';

  const props = withDefaults(
    defineProps<{
      id: string;
      class?: string;
      convention: ConventionDocument;
      on_submit?: Function;
      on_close?: Function;
      open_signature_manuelle?: Function;
      client_id: number;
      title?: string;
      subtitle?: string;
      participant_nom_prenom?: string;
      session_date?: string;
      formation_title?: string;
      signature_manuelle?: boolean;
    }>(),
    {
      class: '',
      title: 'Convention de formation',
      signature_manuelle: false
    }
  );
</script>

<style lang="scss" scoped></style>
